/** Impls dos use cases de Tutoria. @since H.3 */
import type {
  Tutor, UpsertTutorCommand,
  Assunto, UpsertAssuntoCommand,
  Solicitacao, SolicitacaoMensagem, ListSolicitacoesParams,
} from '@/domain/model/Tutoria';
import type { TutorGateway, AssuntoGateway, SolicitacaoGateway } from '@/application/port/out/TutoriaGateways';
import type {
  ListTutoresUseCase, CreateTutorUseCase, UpdateTutorUseCase, ArquivarTutorUseCase,
  ListAssuntosUseCase, CreateAssuntoUseCase, UpdateAssuntoUseCase,
  ListSolicitacoesUseCase, AssumirSolicitacaoUseCase, ListSolicitacaoMensagensUseCase,
  ResponderSolicitacaoUseCase, EncerrarSolicitacaoUseCase,
} from '@/application/port/in/TutoriaUseCase';

export class ListTutores implements ListTutoresUseCase {
  constructor(private readonly g: TutorGateway) {}
  execute(): Promise<Tutor[]> { return this.g.list(); }
}
export class CreateTutor implements CreateTutorUseCase {
  constructor(private readonly g: TutorGateway) {}
  execute(cmd: UpsertTutorCommand): Promise<Tutor> { return this.g.create(cmd); }
}
export class UpdateTutor implements UpdateTutorUseCase {
  constructor(private readonly g: TutorGateway) {}
  execute(id: string, cmd: UpsertTutorCommand): Promise<Tutor> { return this.g.update(id, cmd); }
}
export class ArquivarTutor implements ArquivarTutorUseCase {
  constructor(private readonly g: TutorGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}

export class ListAssuntos implements ListAssuntosUseCase {
  constructor(private readonly g: AssuntoGateway) {}
  execute(): Promise<Assunto[]> { return this.g.list(); }
}
export class CreateAssunto implements CreateAssuntoUseCase {
  constructor(private readonly g: AssuntoGateway) {}
  execute(cmd: UpsertAssuntoCommand): Promise<Assunto> { return this.g.create(cmd); }
}
export class UpdateAssunto implements UpdateAssuntoUseCase {
  constructor(private readonly g: AssuntoGateway) {}
  execute(id: string, cmd: UpsertAssuntoCommand): Promise<Assunto> { return this.g.update(id, cmd); }
}

export class ListSolicitacoes implements ListSolicitacoesUseCase {
  constructor(private readonly g: SolicitacaoGateway) {}
  execute(params: ListSolicitacoesParams): Promise<Solicitacao[]> { return this.g.list(params); }
}
export class AssumirSolicitacao implements AssumirSolicitacaoUseCase {
  constructor(private readonly g: SolicitacaoGateway) {}
  execute(id: string, tutorId: string): Promise<Solicitacao> { return this.g.assumir(id, tutorId); }
}
export class ListSolicitacaoMensagens implements ListSolicitacaoMensagensUseCase {
  constructor(private readonly g: SolicitacaoGateway) {}
  execute(id: string): Promise<SolicitacaoMensagem[]> { return this.g.listMensagens(id); }
}
export class ResponderSolicitacao implements ResponderSolicitacaoUseCase {
  constructor(private readonly g: SolicitacaoGateway) {}
  execute(id: string, corpo: string): Promise<SolicitacaoMensagem> { return this.g.responder(id, corpo); }
}
export class EncerrarSolicitacao implements EncerrarSolicitacaoUseCase {
  constructor(private readonly g: SolicitacaoGateway) {}
  execute(id: string): Promise<Solicitacao> { return this.g.encerrar(id); }
}
